<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h6">
                            IRREGULARIDADE DA FISCALIZAÇÃO
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
                        <b-row>
                            <b-col sm="12" md="12" lg="6" xl="6">
                                <b-form-group>
                                    <label class="required">Conformidade</label>
                                    <b-form-select
                                        :options="conformidades"
                                        v-model="idConformidade"
                                        text-field="nomeConformidade"
                                        value-field="idConformidade"
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-invalid-feedback>
                                    A Conformidade é obrigatória
                                </b-form-invalid-feedback>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group>
                                    <label class="required">Descrição</label>
                                    <b-form-textarea
                                        v-model="descricao"
                                        :rows="4"
                                        @input.native="$v.descricao.$touch()"
                                        :state="$v.descricao.$error ? false : null"
                                    ></b-form-textarea>
                                    <b-form-invalid-feedback>
                                        A Descrição é obrigatória
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <b-form-group>
                                    <label class="required">Anexar Arquivos</label>
                                    <b-form-file
                                        @change="handleFileSelect"
                                        v-model="arquivo"
                                        :state="fileState"
                                        placeholder="Selecione o arquivo..."
                                        ref="arquivoInput"
                                        browse-text="Selecionar"
                                    ></b-form-file>
                                </b-form-group>
                            </b-col>                
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <app-tabela
                                    :itens="arquivos"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina">
                                    <template slot="acoes" slot-scope="data">
                                        <div class="float-left mr-1">
                                            <span class="text-danger">
                                                <i
                                                    class="fa fa-trash fa-lg icon-button"
                                                    title="Excluir Arquivo"
                                                    @click.stop="confirmarExclusaoArquivo(data)"
                                                ></i>
                                            </span>
                                        </div>
                                    </template>
                                </app-tabela>
                            </b-col>
                        </b-row>                        
                    </b-card-body>
                    <b-card-footer>
                        <b-button v-if="habilitado"
                            variant="primary"
                            @click.stop="salvar()"
                            :disabled="desabilitarBtnSalvar"
                            class="mr-2">
                            <i class="fa fa-save"></i> Avaliar
                        </b-button>
                        <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
                            <span>
                                <i class="fa fa-history"></i> Cancelar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import FiscalizacoesServicos from '../FiscalizacoesServicos'
import StatusConformidade from '../enum/StatusConformidadeEnum'
import StatusIrregularidade from '../enum/StatusIrregularidadeEnum'

export default {
    data() {
        return {
            operacao: 'AVALIAR',
            habilitado: true,
            conformidades: [
                {nomeConformidade: "Conforme", idConformidade: 1},
                {nomeConformidade: "Não Conforme", idConformidade: 2}
            ],
            fiscalizacaoId: null,
            idIrregularidadeFiscalizacao: null,
            arquivos: [],
            arquivo: null,
            erros: [],
            idConformidade: 1,
            descricao: '',
            fileState: null,
            itensPorPagina: 10,
            campos: [
                {
                    key: 'name',
                    label: 'Nome',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-left'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ]
        }
    },

    methods: {

        salvarAvaliacaoIrregularidade(avaliacao) {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos
            .avaliarIrregulridadeFiscalizacao(this.idIrregularidadeFiscalizacao, avaliacao)
            .then((response) => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success('Registro salvo com sucesso!', 'OK', this.$toastConfig.success)
            this.cancelar();
        },

        salvar() {
            let avaliacao = {
                conformidade: this.idConformidade,
                descricao: this.descricao,
                anexos: this.arquivos && this.arquivos.length > 0 ? this.arquivos.map(arq => arq.file) : []
            }
            this.salvarAvaliacaoIrregularidade(avaliacao)
        },

        cancelar() {
            this.erros = []
            this.resetForm()
            this.$router.push({
                name: `IrregularidadeFiscalizacao_Detalhe`,
                params: {
                    fiscalizacaoId: this.fiscalizacaoId,
                    idIrregularidadeFiscalizacao: this.idIrregularidadeFiscalizacao
                }
            })
        },

        resetForm() {
            this.arquivos = []
            this.arquivo = null
            this.erros = []
            this.idConformidade = 1
            this.fileState = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencheFormulario() {
            this.descricao = this.fiscalizacao.descricao
            this.observacao = this.fiscalizacao.observacao
        },

        verificarCampoPreenchido(value) {
            if (value == null || value == '' || value == undefined)
                return false
            else
                return true
        },

        handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                this.arquivo = null
                this.$refs.arquivoInput.reset();
                this.arquivos.push({
                    name: file.name,
                    file: file,
                    dataCriacao: new Date().getMilliseconds()
                });
            }
        },

        removerArquivoLista(index) {
            this.arquivos.splice(index, 1);
            // Reseta o campo de arquivo
            this.arquivo = null;
        },

        confirmarExclusaoArquivo(dados) {
            const index = this.arquivos.findIndex(arq => arq.dataCriacao === dados.dataCriacao)

            if (index >= 0) {
                this.$swal({
                        title: 'Confirma a exclusão do arquivo ?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Sim',
                        cancelButtonText: 'Não'
                    }).then((result) => {
                        if (result.value) {
                            this.removerArquivoLista(index)
                        }
                    })

            }
        },

        obterIrregularidadeFiscalizacao(idIrregularidadeFiscalizacao) {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos
                .obterIrregularidadeFiscalizacao(idIrregularidadeFiscalizacao).then(response => {
                if (response) {
                    if (response.success) {
                        this.habilitarBotoes(response.data)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        habilitarBotoes(irregularidadeFiscalizacao) {
            this.habilitado = irregularidadeFiscalizacao && (
                irregularidadeFiscalizacao.numeroStatusConformidade === StatusConformidade.NAO_FISCALIZADO ||
                (irregularidadeFiscalizacao.numeroStatusConformidade === StatusConformidade.NAO_CONFORME && 
                irregularidadeFiscalizacao.numeroStatusIrregularidade === StatusIrregularidade.CORRECAO_EM_ANALISE)
            )
        },

    },

    created() {
        this.fiscalizacaoId = this.$route.params.fiscalizacaoId
        this.idIrregularidadeFiscalizacao = this.$route.params.idIrregularidadeFiscalizacao
        this.obterIrregularidadeFiscalizacao(this.idIrregularidadeFiscalizacao)
    },

    computed: {

        desabilitarBtnSalvar() {
            if (this.$v.$invalid) 
                return true
            else 
                return false
        },

        descricaoValida() {
            return this.verificarCampoPreenchido(this.descricao)
        },

        arquivosValido() {
            return this.arquivos && this.arquivos.length > 0
        }
    },

    validations: {
        idConformidade: {
            required,
        },
        descricao: {
            descricaoValida() {
                return this.descricaoValida
            }
        },
        arquivos: {
            arquivosValidos(value) {
                return this.arquivosValido
            }
        }
    },

    watch: {
        arquivos (newFile) {
            if (!newFile) {
                this.fileState = false;
            } else {
                this.arquivo = null
                this.fileState = true;
            }
        },

        statusModal(newVal) {
            if (!newVal) {
                this.resetForm()
            }
        }
    },

    mounted() {}
}
</script>
